import Header from './Header'
import Card from './Card'
import Corkboard from './Corkboard'
import MissionCard from './MissionCard'
import Chalkboard from './Chalkboard'
import EmailCard from './EmailCard'
import Interactive from './Interactive'

import InteractivesArea from './InteractivesArea'
import Nelson from './Nelson'
import { useEffect, useState } from 'react'

const Exercise = ({ onScreenUpdate }) => {
  const [dialogue, setDialogue] = useState(null)
  const [showDialogue, setShowDialogue] = useState(false)
  const [learnLink, setLearnLink] = useState(null)
  const dialogueLinkText = 'Learn More'

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="mainContainer">
      <audio id="cranberries" src="audio/exercise/cranberries.mp3" />
      <audio id="heart" src="audio/exercise/heart.mp3" />
      <audio id="vial" src="audio/exercise/vial.mp3" />

      <Header onScreenUpdate={onScreenUpdate} />
      <div className="chalkAndIconsAndCork">
        <div className="chalkAndIcons">
          <Chalkboard>
            <div className="chalkboardHeader LithosPro exerciseHeader">
              Exercise Physiology
            </div>
            <div className="chalkboardContent">
              <p>
                Horses love to exercise. Hey, if you could run 40 miles per
                hour, wouldn't you? Interestingly, humans and horses have
                similar exercise physiology (fizzy-all-uh-gee).
              </p>
              <p>
                Physiology is the study of how living things use air, pump
                blood, cool down, burn calories, and more. So, as horses run on
                treadmills and try different foods, scientists learn what's best
                for them, and sometimes for humans, too. Why not exercise your
                mouse finger, click around, and learn more?
              </p>
            </div>
          </Chalkboard>
          <InteractivesArea>
            <Interactive
              cat={'exercise'}
              itemName={'stethoscope'}
              alt={'a stethoscope'}
              url={'FAQ1.html'}
              sound={'heart'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>
                      The oldest human to complete a marathon was 98. Scientists
                      want to know what kept him running. Same with older
                      horses.
                    </p>
                    <p>What should they eat? How much should they exercise?</p>
                    <p>Finding out is the really fun part of equine science.</p>
                  </div>
                )
                setLearnLink('pages/exercise/FAQ1.html')
              }}
            />
            <Interactive
              cat={'exercise'}
              itemName={'cranberryBarrel'}
              alt={'a barrel of cranberries'}
              url={'FAQ2.html'}
              sound={'cranberries'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>
                      Say abracadabra (ab-ruh-ka-dab-ruh). Okay, now say
                      nutraceutical (new-truh-soo-tih-cull).
                    </p>
                    <p>
                      It's not magic, but if cranberries and orange peels can
                      help horses exercise and live longer, it sure would seem
                      like magic.
                    </p>
                  </div>
                )
                setLearnLink('pages/exercise/FAQ2.html')
              }}
            />
            <Interactive
              cat={'exercise'}
              itemName={'shortVial'}
              alt={'a vial of blood'}
              url={'FAQ3.html'}
              sound={'vial'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>Take a deep breath.</p>
                    <p>
                      You've just put oxygen in your blood. Oxygen helps muscles
                      use energy.
                    </p>
                    <p>
                      But it also needs to be controlled by chemicals in blood
                      called antioxidants (ant-eye-ox-uih-dunce).
                    </p>
                  </div>
                )
                setLearnLink('pages/exercise/FAQ3.html')
              }}
            />
          </InteractivesArea>
        </div>
        <Corkboard onScreenUpdate={onScreenUpdate}>
          <MissionCard />
          <EmailCard />
          <Card className="linksCard exerciseLinks">
            <div className="cardTitle linksTitle">Links</div>
            <div className="linksLink">
              <a
                href="pages/exercise/FAQ1.html"
                target="_blank"
                rel="noreferrer"
              >
                Natural Born Athletes
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/exercise/FAQ2.html"
                target="_blank"
                rel="noreferrer"
              >
                Foods for Exercise
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/exercise/FAQ3.html"
                target="_blank"
                rel="noreferrer"
              >
                Oxygen is Important
              </a>
            </div>
            <div className="linksLink">
              <a
                href="https://youtu.be/c87tCgT9ZBU"
                target="_blank"
                rel="noreferrer"
              >
                Video: Horses on Treadmills?
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/exercise/treadmill.html"
                target="_blank"
                rel="noreferrer"
              >
                Treadmill Lab Virtual Tour
              </a>
            </div>
          </Card>
        </Corkboard>
      </div>
      <Nelson
        showDialogue={showDialogue}
        dialogue={dialogue}
        setShowDialogue={setShowDialogue}
        learnLink={learnLink}
        dialogueLinkText={dialogueLinkText}
      />
    </div>
  )
}

export default Exercise
